import { styled, Typography, Switch } from "@mui/material";
const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
})), StyledSwitch = styled(Switch)(({ theme }) => ({
  overflow: "visible",
  padding: "0",
  height: "22px",
  width: "44px",
  alignItems: "center",
  ".MuiSwitch-thumb": {
    width: "22px",
    height: "22px",
    borderRadius: "14px",
    boxShadow: theme.boxShadows.toggle
  },
  ".MuiSwitch-track": {
    backgroundColor: theme.palette.grey[400],
    height: "8px",
    width: "44px",
    borderRadius: "4px",
    opacity: "1"
  },
  "&:hover": {
    ".MuiSwitch-track": {
      backgroundColor: theme.palette.grey[700]
    }
  },
  "&:active": {
    ".MuiSwitch-track": {
      backgroundColor: theme.palette.grey[700]
    }
  },
  "& .MuiSwitch-switchBase": {
    alignItems: "center",
    padding: "0",
    transitionDuration: "250ms",
    "&.Mui-checked": {
      transform: "translateX(22px)",
      color: theme.palette.white.main,
      "&:hover, &:active": {
        backgroundColor: "transparent",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.secondary[1e3]
        }
      },
      "& + .MuiSwitch-track": {
        opacity: "1",
        backgroundColor: theme.palette.secondary[900]
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: theme.palette.grey[500]
      },
      "&.Mui-disabled": {
        color: theme.palette.grey[200]
      }
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: "1",
      backgroundColor: theme.palette.grey[400]
    },
    "&.Mui-disabled": {
      color: theme.palette.grey[200],
      ".MuiSwitch-thumb": {
        boxShadow: "none"
      }
    }
  }
}));
export {
  StyledLabel,
  StyledSwitch
};
//# sourceMappingURL=styles.js.map
